import { useApi } from 'services';

export const useSendQuoteEditEmbed = (idOperation) => useApi(`v2/operation/${idOperation}/quote/send-quote-edit-embed`, 'POST', {}, {});

export const useSaveSelectMarkets = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets`, 'POST', {}, {});

export const useGetSelectedMarkets = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets`, 'GET', {}, {});

export const usePostSelectedMarketsSend = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets/send`, 'POST', {}, {});

export const useUpdateSelectedMarketsStatus = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets/status`, 'PUT', {}, {});

export const useGenerateQuote = (idOperation) => useApi(`v2/operation/${idOperation}/quote/generate-quote`, 'POST', {}, {});

export const useSendQuote = (idOperation) => useApi(`v2/operation/${idOperation}/quote/send`, 'POST', {}, {});

export const useGetPremiumCalculation = (idOperation) => useApi(`v2/operation/${idOperation}/premium-calculation`, 'POST', {}, {});

export const useSavePremiumCalculation = (idOperation) => useApi(`v2/operation/${idOperation}/premium-calculation`, 'PUT', {}, {});

export const useGenerateBindCover = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind/bind-cover`, 'POST', {}, {});

export const useGenerateOrderToBind = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind`, 'POST', {}, {});

export const useGenerateOrderToBindSend = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind/send`, 'POST', {}, {});

export const useGetQuoteExport = () => useApi(`/report/quotes-meridian/xlsx`, 'GET', {}, {});

export const useGenerateQuoteASync = (idOperation) => useApi(`v2/operation/${idOperation}/quote/generate-quote`, 'POST', {}, {}, true);

export const useListMarkets = (idOperation) => useApi(`/quote/list-market/${idOperation}`, 'GET', {}, {}, true);

export const useHeaderNbi = () => useApi(`/quote/header-nbi-request`, 'POST', {}, {}, true);

export const useProcessingPeriodsSchedule = (idOperation) => useApi(`/quote/schedulle/processing-periods/${idOperation}`, 'GET', {}, {}, true);

export const useInsurerValues = (idOperation) => useApi(`/quote/rate/insurers-calcs/${idOperation}`, 'GET', {}, {}, true);

export const useInsurerTaxes = (idOperation) => useApi(`/quote/rate/insurers-taxes/${idOperation}`, 'GET', {}, {}, true);

export const useSaveInsurerTaxes = (idOperation) => useApi(`/quote/rate/insurers-taxes/${idOperation}`, 'POST', {}, {}, true);

export const useListStampsContacts = (idOperation) => useApi(`/quote/policy-stamp/contacts/${idOperation}`, 'GET', {}, {}, true);

export const useScheduleStatus = (idOperation) => useApi(`/quote/schedulle/status/${idOperation}`, 'GET', {}, {}, true);

export const useInsurerLock = () => useApi(`/quote/rate/insurers`, 'POST', {}, {}, true);

export const useImportStatus = (idOperation) => useApi(`/quote/schedulle/import/status/${idOperation}`, 'GET', {}, {}, true);

export const useCreateMarketChangeQuotation = () => useApi(`/endorsement/market-changes/quotation`, 'POST', {}, {}, true);

export const useUpdateNBIManually = () => useApi(`/quote/update-nbi-manually`, 'POST', {}, {}, true);

export const useEndorsementDoc = (idOperation, endorsmentType) => useApi(`/endorsement/${endorsmentType}/save/${idOperation}`, 'POST', {}, {}, true);

export const useScheduleReport = (idOperation) => useApi(`/quote/schedulle/report/${idOperation}`, 'GET', {}, {}, true);

export const useStatusScheduleReport = (idOperation) => useApi(`/quote/schedulle/report-status/${idOperation}`, 'GET', {}, {}, true);

export const useSchedulleConfirm = () => useApi(`/quote/schedulle/confirm`, 'POST', {}, {}, true);

export const useSchedulleExpire = () => useApi('/quote/schedulle/expire', 'POST', {}, {}, true)

export const useGetSchedulleAssumptions = (idOperation) => useApi(`/quote/schedulle/attachment-assumptions/${idOperation}`, 'GET', {}, {}, true);

export const useMrcComplementary = (idOperation) => useApi(`/quote/mrc/complementary/${idOperation}`, 'GET', {}, {}, true);

export const useMRCModal = (idOperation) => useApi(`/quote/mrc/modal/show/${idOperation}`, 'GET', {}, {}, true);

export const useGenerateWording = (idOperation) => useApi(`/quote/wording/${idOperation}`, 'GET', {}, {}, true);

export const useGetDocuments = (idOperation) => useApi(`/quote/wording/attachments/${idOperation}`, 'GET', {}, {}, true);

export const useWordingModal = (idOperation) => useApi(`/quote/wording/modal/show/${idOperation}`, 'GET', {}, {}, true);

export const useGetEnablePolicy = (idOperation) => useApi(`/quote/wording/enable/policy/${idOperation}`, 'GET', {}, {}, true);

export const useWordingHtmlModal = (idOperation) => useApi(`/quote/policy/${idOperation}`, 'GET', {}, {}, true);

export const useGetDocumentsEndorsementContracts = (idOperation) => useApi(`/quote/wording/attachments-endorsement-contract/${idOperation}`, 'GET', {}, {}, true);

export const useEndorsementSigners = (idOperation) => useApi(`/endorsements/signers/${idOperation}`, 'GET', {}, {}, true);

export const useBindMessage = (idOperation) => useApi(`/quote/bind/${idOperation}`, 'GET', {}, {}, true);

export const useListContactsByType = (type, idOperation) => useApi(`/quote/${type}/list-contacts/${idOperation}?`, 'GET', {}, {}, true);

export const useIsApprovedBind = (idOperation) => useApi(`/quote/bind/status-approved/${idOperation}`, 'GET', {}, {}, true);

export const useGetAuthorizationPolicyDocuments = (idOperation) => useApi(`/quote/bind/authorization-policy-documents/${idOperation}`, 'GET', {}, {}, true);

export const useCreatePolicyPack = (idOperation) => useApi(`/quote/policy/create/${idOperation}`, 'POST', {}, {}, true);

export const useWordingSendApproval = () => useApi(`/quote/policy/send-approval`, 'POST', {}, {}, true);

export const useFileNbiEmail = () => useApi(`/quote/show/nbi-request-email`, 'POST', {}, {}, true);

export const useFileNbiEmailUpdated = () => useApi(`/quote/update/nbi-request-email`, 'PUT', {}, {}, true);

export const useAproveNbiReq = () => useApi(`/quote/approve-nbi-request`, 'POST', {}, {}, true);

export const useMarketsResponse = (idOperation) => useApi(`/quote/markets-reponse/${idOperation}`, 'GET', {}, {}, true);

export const useAddQuoteQuestionnaireMas = () => useApi(`/quote/mas/questionnaire`, 'POST', {}, {}, true);

export const useListBrokers = (idOperation) => useApi(`/quote/list-brokers/${idOperation}`, 'GET', {}, {}, true);

export const useDocument = () => useApi(`/quote/document`, 'POST', {}, {}, true);

export const useSendApprove = () => useApi(`/quote/send-approval-nbi-client`, 'POST', {}, {}, true);

export const useListClientContacts = (idOperation) => useApi(`/quote/list-client-contacts/${idOperation}`, 'GET', {}, {}, true);

export const useSentEmailClient = () => useApi(`/quote/sent-email-client`, 'POST', {}, {}, true);

export const useGetPolicyStampStatus = (idOperation) => useApi(`/quote/policy-stamp/${idOperation}`, 'GET', {}, {}, true);

export const useEndorsementPackRiskMarketChangesLastQuestionnaireMrc = (idOperation) => useApi(`/endorsement/market-changes/last-questionnaire-mrc/${idOperation}`, 'GET', {}, {}, true);

export const useEndorsementPackRiskMarketChangesListPreviewDocuments = (idOperation) => useApi(`/endorsement/market-changes/list-preview-documents/${idOperation}`, 'GET', {}, {}, true);

export const useBind = (idOperation, action) => useApi(`/quote/bind/${idOperation}/${action}`, 'POST', {}, {}, true);

export const useGetEditWordingUrl = (idOperation) => useApi(`/quote/wording/report/access/${idOperation}`, 'GET', {}, {}, true);

export const usePolicyPackSendDirectorApproval = () => useApi(`/quote/policy/director-approval/send`, 'POST', {}, {}, true);

export const useMrc1 = (idOperation) => useApi(`/quote/mrc/part1/save/${idOperation}`, 'POST', {}, {}, true);

export const useMrc2 = (idOperation) => useApi(`/quote/mrc/part2/save/${idOperation}`, 'POST', {}, {}, true);